import { StateCreator } from 'zustand';
import { useGroupsStore } from '../groupsStore';
import { AclDataSlice } from './createAclDataSlice';
import { AclModalSlice } from './createAclModalSlice';

type IexpandedKeysVsID = Record<string, string[]>;

export interface AclUiSlice {
  isLoadingACLtreeData: boolean;
  expandedKeysVsID: IexpandedKeysVsID | null;
  expandedKeysVmTree: string[];
  searchValue: string;
  autoExpandParent: boolean;
  isEditedTree: boolean;

  setIsLoadingACLtreeData: (status: boolean) => void;
  setGroupExpandedKeys: (expandedKeys: string[]) => void;
  setIsEditedTree: (value: boolean) => void;
  setSearchValue: (value: string) => void;
  setAutoExpandParent: (value: boolean) => void;
}

export const ACL_UI_INITIAL_STATE: Pick<AclUiSlice, 'isLoadingACLtreeData' | 'expandedKeysVsID' | 'expandedKeysVmTree' | 'searchValue' | 'autoExpandParent' | 'isEditedTree'> = {
  isLoadingACLtreeData: false,
  expandedKeysVsID: null,
  expandedKeysVmTree: [],
  searchValue: '',
  autoExpandParent: false,
  isEditedTree: false,
};

export const createAclUiSlice: StateCreator<
  AclDataSlice & AclUiSlice & AclModalSlice,
  [],
  [],
  AclUiSlice
> = (set) => ({
  ...ACL_UI_INITIAL_STATE,

  setIsLoadingACLtreeData: (status) => set({ isLoadingACLtreeData: status }),
  setGroupExpandedKeys: (expandedKeys) => {
    const groupId = useGroupsStore.getState().selectedDataGroup?.key;
    if (!groupId) return;
    set((state) => ({
      expandedKeysVsID: {
        ...state.expandedKeysVsID,
        [groupId]: expandedKeys,
      },
    }));
  },
  setIsEditedTree: (value) => set({ isEditedTree: value }),
  setSearchValue: (value) => set({ searchValue: value }),
  setAutoExpandParent: (value) => set({ autoExpandParent: value }),
});
